import React, { useContext } from 'react';
import styles from './AdviseChanges.styles.js';
import { AppContext } from 'App.context.js';
import { EyeOutlined } from '@ant-design/icons';

export default function AdviceChanges({
  applyToAllHotels,
  updateSenderRecipients,
  hotelsSelector,
}) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const list1 = translate('mailTemplates.adviceChangesList1').split('\n');
  const list2 = translate('mailTemplates.adviceChangesList2').split('\n');

  let itemList = '';
  if (updateSenderRecipients) {
    itemList = list1.map(item => {
      return <div style={styles.desc}>{item}</div>;
    });
  } else {
    itemList = list2.map(item => {
      return <div style={styles.desc}>{item}</div>;
    });
  }

  return (
    <div>
      <div style={styles.desc}>{translate('mailTemplates.adviceChanges')}</div>
      {itemList}

      {applyToAllHotels ? (
        <div>
          <div style={styles.descWarn}>
            <b>
              <EyeOutlined />
              {` ${translate('mailTemplates.adviceChangesAll')}`}
            </b>
          </div>
          {updateSenderRecipients ? (
            <div>
              <div style={styles.desc}>
                <b>{translate('mailTemplates.adviseTemplates.secondLine')}</b>
              </div>
            </div>
          ) : (
            <div>
              <div>
                <div style={styles.desc}>
                  <b>{translate('mailTemplates.adviseTemplates.firstLineAll')}</b>
                </div>
                <div style={styles.desc}>
                  <b>{translate('mailTemplates.adviseTemplates.secondLine')}</b>
                </div>
                <div style={styles.desc}>
                  <b>{translate('mailTemplates.adviseTemplates.thirdLine')}</b>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        ''
      )}
      {hotelsSelector ? (
        <div>
          <div style={styles.descWarn}>
            <b>
              <EyeOutlined />
              {` ${translate('mailTemplates.adviceChangesSelector')}`}
            </b>
          </div>
          {updateSenderRecipients ? (
            <div>
              <div style={styles.desc}>
                <b>{translate('mailTemplates.adviseTemplates.secondLine')}</b>
              </div>
            </div>
          ) : (
            <div>
              <div>
                <div style={styles.desc}>
                  <b>{translate('mailTemplates.adviseTemplates.firstLine')}</b>
                </div>
                <div style={styles.desc}>
                  <b>{translate('mailTemplates.adviseTemplates.secondLine')}</b>
                </div>
                <div style={styles.desc}>
                  <b>{translate('mailTemplates.adviseTemplates.thirdLine')}</b>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
